<template>
  <div>
    <v-navigation-drawer
        v-model="drawer"
        app
        temporary
        dark
        src="@/assets/img/bgEnd.png"
    >
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">Concord Dentist</v-list-item-title>
            <v-list-item-subtitle>Glo Dentistry</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list dense>
        <v-list-item
            v-for="([icon, text, link], i) in items"
            :key="i"
            :href="link.startsWith('http') ? link : null"
            @click="link.startsWith('#') ? $vuetify.goTo(link) : navigateToLink(link)"
        >
          <v-list-item-icon class="justify-center">
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="subtitile-1">{{ text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
        app
        :color="color"
        :flat="flat"
        dark
        class="px-15"
        :class="{ expand: flat }"
    >
      <v-toolbar-title>
        <v-img src="@/assets/img/logo.png" max-width="250px" />
      </v-toolbar-title>
      <v-spacer />
      <v-app-bar-nav-icon
          @click.stop="drawer = !drawer"
          class="mr-4"
          v-if="isXs"
      />
      <div v-else>
        <v-btn text @click="$vuetify.goTo('#home')">
          <span class="mr-2">Home</span>
        </v-btn>
        <v-btn text @click="$vuetify.goTo('#treatments')">
          <span class="mr-2">Treatments</span>
        </v-btn>
        <v-btn text @click="$vuetify.goTo('#specials')">
          <span class="mr-2">Specials</span>
        </v-btn>
        <v-btn text @click="$vuetify.goTo('#contact')">
          <span class="mr-2">Contact</span>
        </v-btn>
        <v-btn rounded outlined text @click="navigateToLink('https://bookit.dentrixascend.com/v1/view/organization/9526/index.html?mode=externalLink#/perspectives/3')">
          <span class="mr-2">Book Online</span>
        </v-btn>
      </div>
    </v-app-bar>
  </div>
</template>

<style scoped>
.v-toolbar {
  transition: 0.6s;
}

.expand {
  height: 80px !important;
  padding-top: 10px;
}
</style>

<script>
export default {
  data: () => ({
    drawer: null,
    isXs: false,
    items: [
      ["mdi-home-outline", "Home", "#home"],
      ["mdi-information-outline", "Treatments", "#treatments"],
      ["mdi-gift-outline", "Specials", "#specials"],
      ["mdi-phone-outline", "Contact", "#contact"],
      ["mdi-calendar-outline", "Book Online", "https://bookit.dentrixascend.com/v1/view/organization/9526/index.html?mode=externalLink#/perspectives/3"],
    ],
  }),
  props: {
    color: String,
    flat: Boolean,
  },
  methods: {
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
    navigateToLink(link) {
      if (link.startsWith('http')) {
        window.location.href = link;
      }
    }
  },

  watch: {
    isXs(value) {
      if (!value && this.drawer) {
        this.drawer = false;
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
};
</script>
